<template>
  <div class="container">
    <!--banner start-->

    <div class="speaker-header">
      <div class="speaker-header-head">
        <h1 :class="`entry-title ${isMobile?'mobile':''}`" v-text="$t('route.speakerBios')" />
      </div>
      <div class="speaker-header-breadcrumbs">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }" v-text="$t('route.home')" />
            </li>
            <li class="breadcrumb-item active" aria-current="page" v-text="$t('route.speakerBios')"></li>
          </ol>
        </nav>
      </div>
    </div>

    <!--banner end-->
    <!--searchvedios block start-->
    <div class="speaker-main">
      <infinite-container
        :handler="handleLoadmore"
        :processing="infiniteData.isProcessing"
        :is-loadmore="isLoadMore"
        :class-name="'list-card'"
      >
        <ul class="d-flex flex-wrap">
          <li
            v-for="speaker in infiniteData.source"
            :key="speaker.slug"
            class="col-12 col-md-6 col-lg-4 col-xl-3"
          >
            <router-link
              :to="{ name: 'speaker', params: {slug: speaker.slug} }"
              class="speaker-item"
            >
              <div class="speaker-one" :style="`background-image: url(${speaker.thumbnail});`">
                <!-- <img :src="speaker.thumbnail" width="453" height="262" :alt="speaker.name" /> -->
                <div class="speaker-arrow-container">
                  <log-out-icon size="3x" class="speaker-arrow-icon" />
                </div>
              </div>
              <div class="speaker-des">
                <h3>{{speaker.name}}</h3>
              </div>
            </router-link>
          </li>
        </ul>
      </infinite-container>
    </div>
    <!--searchvedios block end-->
  </div>
</template>

<script>
import { isEmpty, cloneDeep, size, includes, filter } from 'lodash'
import { mapState } from 'vuex'
import { LogOutIcon } from 'vue-feather-icons'
import slug from '@/utils/slug'
import InfiniteContainer from '@/components/InfiniteContainer'
import deviceDetected from '@/utils/detect-device'

export default {
  name: 'SpeakerBios',
  components: {
    LogOutIcon,
    InfiniteContainer
  },
  data: () => ({
    infiniteData: {
      pageSize: 4,
      currentPage: 1,
      isProcessing: false,
      number: 1,
      source: []
    },
    inputSearch: '',
    speakerList: []
  }),
  watch: {
    inputSearch(val) {
      this.$set(this.infiniteData, 'currentPage', 1)
      this.speakerList = filter(cloneDeep(this.speakers), speaker => includes(slug(speaker.title), slug(val)))
    },
    speakerList(val) {
      const pages = (size(val) / this.infiniteData.pageSize) >> 0
      const extra = size(val) % this.infiniteData.pageSize
      this.$set(this.infiniteData, 'number', extra > 0 ? pages + 1 : pages)
      this.handleInifiniteData()
    }
  },
  computed: {
    ...mapState({
      speakers: 'speakers'
    }),
    isMobile() {
      return deviceDetected.isMobile()
    },

    isLoadMore() {
      return this.infiniteData.source.length < this.speakerList.length
    }
  },
  async created() {
    await this.doInitData()
    this.speakerList = cloneDeep(this.speakers)
    this.handleInifiniteData()
  },
  methods: {
    isEmpty,
    async doInitData() {
      try {
        if (isEmpty(this.speakers)) {
          await this.$store.dispatch('fetchSpeakers')
        } else {
          this.$store.dispatch('hideLoader')
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleLoadmore(page) {
      this.$set(this.infiniteData, 'isProcessing', true)
      this.$set(this.infiniteData, 'currentPage', this.infiniteData.currentPage + 1)
      setTimeout(() => {
        this.handleInifiniteData()
        this.$set(this.infiniteData, 'isProcessing', false)
      }, 300)
    },
    handleInifiniteData() {
      this.$set(this.infiniteData, 'source', this.speakerList.slice(0, this.infiniteData.currentPage * this.infiniteData.pageSize))
    }
  }
}
</script>
<style lang="scss">
.speaker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &-head {
    color: #2ba349;
    .entry-title {
      font-size: 52px;
      line-height: 62px;
      &.mobile {
        font-size: 30px;
        line-height: 30px;
      }
    }
  }
  &-breadcrumbs {
    .breadcrumb {
      font-weight: 300;
      color: #adb0b6;
      font-size: 13px;
      line-height: 25px;
      text-transform: none;
      background-color: transparent;
      padding: 3px 12px 2px 12px;
      margin: 0;
      &-item {
        &.active,
        &::before {
          color: #adb0b6;
        }
      }
      a {
        color: #adb0b6;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
.speaker-main {
  margin-top: 30px;

  .speaker-item {
    .speaker-one {
      border-radius: 10px 10px 0 0;
      height: 375px;
      width: 100%;
      background-repeat: no-repeat;
      background-position: center;
      position: relative;
      background-size: cover;
      a {
        display: block;
      }
      img {
        height: 375px;
        width: auto;
        object-fit: cover;
        transition: opacity 0.25s ease-in-out;
      }
      &:hover {
        img {
          opacity: 0.3;
        }
        .speaker-arrow-container {
          opacity: 1;
        }
      }
    }
    .speaker-arrow-container {
      border-radius: 10px 10px 0 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: opacity 0.25s ease-in-out;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(#2ba048, 0.7);
    }

    .speaker-des {
      border-radius: 0 0 10px 10px;
      padding: 25px 0;
      background-color: #333333;
      margin-bottom: 30px;
      h3 {
        color: #fff;
        font-size: 14px;
        line-height: 1.5;
        text-align: center;
        text-transform: uppercase;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        &:hover {
          color: #2ba048;
        }
      }
    }
    .speaker-arrow-icon {
      color: #fff;
    }
  }
}
</style>
